import { render, staticRenderFns } from "./location-management.vue?vue&type=template&id=754965a4&scoped=true&"
import script from "./location-management.vue?vue&type=script&lang=js&"
export * from "./location-management.vue?vue&type=script&lang=js&"
import style0 from "./location-management.vue?vue&type=style&index=0&id=754965a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754965a4",
  null
  
)

export default component.exports